import { createContext } from 'react'

import { CommonFormContextProps } from 'components/Form'
import { GamOrderRetargetingDealsDeliverySlice } from './hooks/useGetGamOrderRetargetingDealsDelivery'

export const SetupRetargetingDeliveryItemsContext =
  createContext<SetupRetargetingDeliveryItemsContextType>(
    {} as SetupRetargetingDeliveryItemsContextType,
  )

export type SetupRetargetingDeliveryItemsContextType = CommonFormContextProps & {
  gamOrderRetargetingDealsDelivery?: GamOrderRetargetingDealsDeliverySlice
}
